import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { TeamsDetailsComponent } from './teams-details/teams-details.component';
import { TeamsAddComponent } from './teams-add/teams-add.component';
import { TeamsEditComponent } from './teams-edit/teams-edit.component';
import { TeamsDeleteComponent } from './teams-delete/teams-delete.component';

const teamsRoutes: Routes = [
  { path: 'teams/:cnpj/new', component: TeamsAddComponent },
  { path: 'teams/:cnpj/:id', component: TeamsDetailsComponent },
  { path: 'teams/:cnpj/:id/edit', component: TeamsEditComponent },
  { path: 'teams/:cnpj/:id/delete', component: TeamsDeleteComponent },
];

@NgModule({
  imports: [
    RouterModule.forChild(teamsRoutes)
  ],
  exports: [
    RouterModule
  ]
})
export class TeamsRoutingModule { }
